import type { Device } from '@/types/api';
import { deviceStatus } from './device-status';

export interface ConnectingTarget {
  deviceId: string;
  serialNumber: string;
  unitNumber: string;
}

// Pure, unit-testable: has the target device landed its join/transmission?
// Matches on device id first, then serial (case-insensitive) as a fallback,
// and requires `recognized` status — never merely "present in the list", so a
// transient poll can't be mistaken for a successful connect.
export function isTargetConnected(devices: Device[], target: ConnectingTarget): boolean {
  const match = devices.find(
    (d) =>
      d.id === target.deviceId ||
      (d.serialNumber?.toUpperCase() ?? '') === target.serialNumber.toUpperCase(),
  );
  return !!match && deviceStatus(match) === 'recognized';
}
